import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div 
      className="faq-item" 
      onClick={() => setIsOpen(!isOpen)} 
      style={{ borderBottom: '1px solid #d1b892', padding: '25px 0', cursor: 'pointer' }}
    >
      <div className="faq-question" style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', alignItems: 'center' }}>
        <span style={{ fontSize: '1.2rem' }}>{question}</span>
        {/* Animace rotace pro plus/mínus */}
        <motion.span 
          animate={{ rotate: isOpen ? 180 : 0 }} 
          style={{ fontSize: '1.5rem', color: '#8b5a2b' }}
        >
          {isOpen ? '−' : '+'}
        </motion.span>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            style={{ overflow: 'hidden' }}
          >
            <div style={{ marginTop: '12px', fontSize: '1.05rem', lineHeight: '1.6', color: '#5a4935' }}>
              {answer}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  return (
    <section id="faq" style={{ padding: '100px 20px', backgroundColor: '#FEF0D7', color: '#2b1f18', overflow: 'hidden' }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <p style={{ textAlign: 'center', fontStyle: 'italic', fontSize: '1.2rem', marginBottom: '12px' }}>FAQ</p>
        <h2 style={{ textAlign: 'center', fontSize: '3rem', fontWeight: '700', marginBottom: '70px' }}>Nejčastější dotazy</h2>
      </motion.div>
      
      <div style={{ maxWidth: '1200px', margin: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px' }}>
        
        {/* LEVÝ SLOUPEC s postupným objevováním */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <FAQItem question="Jak dlouho trvá výroba zakázky?" answer="Obvykle 2–4 týdny dle složitosti a typu výrobku." />
          <FAQItem question="Jaké druhy dřeva používáte?" answer="Nejčastěji používám dub, jasan, lípu a smrk – dle potřeby a charakteru výrobku." />
          <FAQItem question="Je možné vyrobit produkt dle mého návrhu?" answer="Ano, miluji individuální projekty. Můžeme se potkat osobně nebo komunikovat online." />
          <FAQItem question="Nabízíte dopravu nebo montáž?" answer="Ano, po domluvě zajistím jak dopravu, tak případnou instalaci." />
        </motion.div>

        {/* PRAVÝ SLOUPEC s postupným objevováním */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <FAQItem question="Kolik stojí konzultace nebo návrh?" answer="Úvodní konzultace je zdarma, návrh se domlouvá individuálně podle rozsahu." />
          <FAQItem question="Jak probíhá platba za zakázku?" answer="Platí se záloha předem a doplatek při převzetí hotového díla." />
          <FAQItem question="Poskytujete záruční nebo pozáruční servis?" answer="Samozřejmě, poskytujeme jak záruční servis, tak opravy po dohodě." />
          <FAQItem question="Jak mám pečovat o dřevěné výrobky?" answer="Doporučuji občasné olejování a chránit před přímou vlhkostí či prudkým sluncem." />
        </motion.div>

      </div>
    </section>
  );
};

export default FAQ;